import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { Maintenance } from '@app/models/maintenance.model';
import { MaintenanceAdapter } from '@app/adapters/maintenance.adapter';
import { MaintenanceInterface } from '@app/interfaces/_index';
import { NotificationService } from '@app/services/wordpress/notification.service';
import { SessionStorageKeys } from '@app/enums/session-storage-keys.enum';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss'],
  standalone: false,
})
export class NotificationBannerComponent implements OnInit, OnDestroy {
  maintenance: Maintenance;
  subs: Subscription[] = [];
  @Output() closeMaintenance = new EventEmitter<boolean>();

  constructor(
    private notificationService: NotificationService,
    public cdRef: ChangeDetectorRef,
    private maintenanceAdapter: MaintenanceAdapter
  ) {}

  /**
   * On Init, call getMaintenance to load data
   */
  ngOnInit(): void {
    this.getMaintenance();
  }

  /**
   * Subscribe to maintenance service
   * Check the local storage to see if the notification message flag is true, meaning
   * it has been closed by the user and has been read. Else show the notification banner message if false.
   */
  getMaintenance(): void {
    this.subs.push(
      this.notificationService.getMaintenance().subscribe((maintenance: MaintenanceInterface) => {
        let storedMaintenance: any;
        let maintenanceObj;
        // TODO: Refactor this in Angular 16 upgrade
        if (maintenance[0] && maintenance[0]?.acf) {
          // TODO: Store the display notification no tthe full acf
          this.maintenance = this.maintenanceAdapter.adapt(maintenance[0]);
          maintenanceObj = {};
          maintenanceObj.maintenanceFlag = this.maintenance.display_notification;
          maintenanceObj.maintenanceDate = this.maintenance.modifiedDate;

          /* istanbul ignore else */
          if (localStorage.getItem(SessionStorageKeys.MAINTENANCE)) {
            storedMaintenance = JSON.parse(localStorage.getItem(SessionStorageKeys.MAINTENANCE));
            if (this.isUpdatedMaintenanceDate(this.maintenance, storedMaintenance)) {
              maintenanceObj.maintenanceFlag = storedMaintenance.maintenanceFlag;
              this.maintenance.display_notification = storedMaintenance.maintenanceFlag;
            }
          }
          this.setMaintenance(maintenanceObj);
        }
      })
    );
  }

  /**
   * Checking if the date is update based on condition
   * @param maintenance - maintenance data from API
   * @param storedMaintenance - stored Mainteance from Local Storage
   * @returns boolean value based on condition
   */
  isUpdatedMaintenanceDate(maintenance: any, storedMaintenance: any): boolean {
    const oldMaintenanceDate: any = new Date(storedMaintenance.maintenanceDate);
    const newMaintenanceDate: any = new Date(maintenance.modifiedDate);
    const oneDay = 24 * 60 * 60 * 1000;
    const diffDays = Math.round((oldMaintenanceDate - newMaintenanceDate) / oneDay);

    if (diffDays < 60 && diffDays > 0) {
      return true;
    }
    return false;
  }

  /**
   * Close the Notification
   * @param maintenance return maintenance data
   */
  closeMaintenanceNotification(maintenance): void {
    if (this.maintenance) {
      this.maintenance.display_notification = false;
    }

    const maintenanceObj = {
      maintenanceFlag: false,
      maintenanceDate: maintenance.modifiedDate,
    };
    this.setMaintenance(maintenanceObj);
    this.cdRef.detectChanges();
    this.closeMaintenance.emit(false);
  }

  /**
   * Set maintenance object to local storage
   * @param maintenanceObj - maintenance object taht is to be set in local storage
   */
  setMaintenance(maintenanceObj: any): void {
    localStorage.setItem(SessionStorageKeys.MAINTENANCE, JSON.stringify(maintenanceObj));
  }

  /**
   * On Destroy, unsubscribe subscriptions to prevent memory leaks
   */
  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
